import {DataObjectId, GroupChat, Voting} from 'yougile-model'
import {PermissionsChecker} from '@client/permissions-checker'
import {globals} from '@extensions/globals-base'
import {getTaskOrFromNews} from './get-task-or-from-news'

export const showVotingResults = (
  hubId?: DataObjectId,
  voting?: Voting
): boolean => {
  const hub = getTaskOrFromNews(hubId)
  if (!hub) {
    return true
  }

  const allowed =
    PermissionsChecker.checkSendMessages(hub) || GroupChat.isGroupChat(hub)

  if (!allowed) {
    return true
  }

  if (!voting || !voting.votes) {
    return false
  }

  return voting.votes[globals.currentUserId] !== undefined
}
